import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '@services/auth.service';
import { DialogService } from '@services/dialog.service';
import { ErrorService } from '@services/error.service';
import { ISsoReply, SsoService } from '@services/sso.service';
import { PartyService } from '@services/party.service';

import { User } from '@models/user';

@Component({
  selector: 'app-sso-signup-modal',
  templateUrl: './sso-signup-modal.component.html',
  styleUrls: ['./sso-signup-modal.component.scss'],
  standalone: false
})
export class SsoSignupModalComponent implements OnInit, OnDestroy {

  @Input() public state: string = "";

  private authServiceSubscription: Subscription | null = null;
  public currentUser: User | null = null;
  public loading: boolean = true;
  public ssoUserExists: boolean = false;
  public linkingSso: boolean = false;
  public registeringSso: boolean = false;

  public remindingLater: boolean = false;

  constructor(
    private modalService: NgbModal,
    private errorService: ErrorService,
    private ssoService: SsoService,
    private partyService: PartyService,
    private authService: AuthService,
    private translateService: TranslateService,
    private dialogService: DialogService,
  ) { }

  ngOnInit(): void {
    this.authServiceSubscription = this.authService.getCurrentUser$().subscribe((user: User | null) => {
      this.loading = true;
      this.currentUser = user;

      this.ssoUserExists = false;
      if (user) {
        this.ssoService.checkEmail(this.currentUser?.email!).then((reply: ISsoReply) => {
          this.loading = false;
          if (reply.externalAuthId) {
            this.ssoUserExists = true;
          }
        });
      }
    });
  }

  ngOnDestroy(): void {
    if (this.authServiceSubscription) {
      this.authServiceSubscription.unsubscribe();
    }
  }

  public exitModal() {
    this.modalService.dismissAll();
  }

  public remindLater() {
    this.remindingLater = true;
    this.partyService.setAttribute(this.currentUser?.partyId!, 'SSO_REMIND_LATER', `${(new Date()).getTime()}`).then(() => {
      this.remindingLater = false;
      this.modalService.dismissAll();
    }).catch((err: any) => {
      this.remindingLater = false;
      this.modalService.dismissAll();
    });
  }

  public redirectToRegister() {
    this.registeringSso = true;

    this.authService.getCurrentUser().then((user) => {
      this.ssoService.redirectToRegister(user!, 'sso_modal');
    }).catch((err) => {
      this.errorService.printError(err);
      this.dialogService.alert('Error', this.translateService.instant('Common.text_genericError'));
    });
  }

  public redirectToSignInAndLink(): void {
    this.linkingSso = true;

    this.authService.getCurrentUser().then((user) => {
      this.ssoService.redirectToLogin('sso_modal');
    }).catch((err) => {
      this.errorService.printError(err);
      this.dialogService.alert('Error', this.translateService.instant('Common.text_genericError'));
    });
  }
}
